import { Input, Label } from 'reactstrap';
import { InputType } from 'reactstrap/types/lib/Input';
// import { FindCourseCheckbox } from '../../../../../../data/miscellaneous/Learning';
import { use, useEffect, useState } from 'react';
import { CheckboxListsProps, CourseStateStatus } from '../../../../../../types/Courses';
import { useTranslation } from 'react-i18next';

const CheckboxLists = ({
  categoriesFilterSelectors,
  durationFilterSelectors,
  status,
  setFilters,
}: Partial<CheckboxListsProps>) => {
  const { t, i18n } = useTranslation();
  const [checkboxList, setCheckboxList] = useState<
    {
      id: number;
      title: string;
      child: { id: number; name: string; text: string; type: string }[];
    }[]
  >([]);

  useEffect(() => {
    if (categoriesFilterSelectors) {
      const mergedSelectors = [
        {
          id: 1,
          title: categoriesFilterSelectors?.categories?.filterName || 'Categories',
          child: (categoriesFilterSelectors?.categories?.filterSelectors || []).map(
            (item: any) => ({
              id: item.id,
              name: item.name,
              text: item.text ?? '',
              type: item.type ?? 'checkbox',
            }),
          ),
        },
        {
          id: 2,
          title: durationFilterSelectors?.duration?.filterName || 'Duration',
          child: (durationFilterSelectors?.duration?.filterSelectors || []).map((item: any) => ({
            id: item.id,
            name: item.name,
            text: item.text ?? '',
            type: item.type ?? 'checkbox',
          })),
        },
        {
          id: 3,
          title: t('filters.filterStatus'),
          child: [
            {
              id: 30,
              name: 'in_progress',
              text: t('courses.courseStudyStatus.inProgress'),
              type: 'checkbox',
            },
            {
              id: 31,
              name: 'completed',
              text: t('courses.courseStudyStatus.completed'),
              type: 'checkbox',
            },
          ],
        },
      ];
      setCheckboxList(mergedSelectors);
    } else {
      const mergedSelectors = [
        {
          id: 2,
          title: durationFilterSelectors?.duration?.filterName || 'Duration',
          child: (durationFilterSelectors?.duration?.filterSelectors || []).map((item: any) => ({
            id: item.id,
            name: item.name,
            text: item.text ?? '',
            type: item.type ?? 'checkbox',
          })),
        },
        {
          id: 3,
          title: t('filters.filterStatus'),
          child: [
            {
              id: 52,
              name: 'in_progress',
              text: t('courses.courseStudyStatus.inProgress'),
              type: 'checkbox',
            },
            {
              id: 53,
              name: 'completed',
              text: t('courses.courseStudyStatus.completed'),
              type: 'checkbox',
            },
            {
              id: 54,
              name: 'pending',
              text: t('courses.coursesStatus.pending'),
              type: 'checkbox',
            },
          ],
        },
      ];
      setCheckboxList(mergedSelectors);
    }
  }, [categoriesFilterSelectors, durationFilterSelectors, i18n.language]);

  return (
    <>
      {checkboxList.map((data) => (
        <div className={`checkbox-animated ${data.id !== 1 ? 'mt-0' : ''}`} key={data.id}>
          <div className="learning-header">
            <span className="f-w-600">{data.title}</span>
          </div>
          {data.child.map((item) => (
            <Label className="d-block" htmlFor={`ani-${data.id}-${item.id}`} key={item.id}>
              <Input
                className={data.id === 6 ? 'radio_animated' : 'checkbox_animated'}
                id={`ani-${data.id}-${item.id}`}
                type={item.type as InputType}
                name={item.name ? item.name : ''}
                // defaultChecked={item.check ? true : false}
                onChange={(e) => {
                  if (setFilters) {
                    setFilters((prev: any) => {
                      const updatedFilters = { ...prev };
                      if (data.id === 1) {
                        // Categories
                        const categoryId = item.id;
                        if (e.target.checked) {
                          updatedFilters.category.push(categoryId);
                        } else {
                          updatedFilters.category = updatedFilters.category.filter(
                            (id: any) => id !== categoryId,
                          );
                        }
                      } else if (data.id === 2) {
                        // Duration
                        const durationId = item.id;
                        if (e.target.checked) {
                          updatedFilters.duration.push(durationId);
                        } else {
                          updatedFilters.duration = updatedFilters.duration.filter(
                            (id: any) => id !== durationId,
                          );
                        }
                      } else if (data.id === 3) {
                        if (e.target.checked) {
                          if (
                            item.name === 'pending' ||
                            item.name === 'active' ||
                            item.name === 'inactive'
                          ) {
                            updatedFilters.courseStateStatus.push(item.name as CourseStateStatus);
                          } else {
                            updatedFilters.status.push(item.name);
                          }
                        } else {
                          if (
                            item.name === 'pending' ||
                            item.name === 'active' ||
                            item.name === 'inactive'
                          ) {
                            updatedFilters.courseStateStatus =
                              updatedFilters.courseStateStatus.filter(
                                (name: CourseStateStatus) => name !== item.name,
                              );
                          } else {
                            updatedFilters.status = updatedFilters.status.filter(
                              (name: string) => name !== item.name,
                            );
                          }
                        }
                      }
                      return updatedFilters;
                    });
                  }
                }}
              />
              {item.text}
            </Label>
          ))}
        </div>
      ))}
    </>
  );
};
export default CheckboxLists;
